<template>
  <div style="height: 50vh">
  </div>
</template>

<script>

export default {
  name: 'Logout',
  data() {
    return {
    }
  },
  async mounted() {


      this.$loading({
        lock: true,
        text: 'Saindo...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });
      setTimeout(() => {
        this.$store.dispatch('user/clear')
        if (localStorage.getItem('user')) {
          try {
            localStorage.removeItem('user');
            this.$router.go('/login');
          } catch(e) {
            this.$router.go('/login');
          }
        }
        // loading.close();

      }, 1000);

  },
  methods: {

  }

}
</script>

<style scoped>

</style>
